<template>
  <transition name="fade">
    <Login v-if="showLogin" />
  </transition>

  <div class="container">
    <el-row>
      <el-col :span="5">
      </el-col>
      <el-col :span="8">
        <div class="tool title">交易所</div>
        <div class="item" v-loading="binanceLoading" element-loading-text="正在验证 API KEY ...">
          <div class="avatar" @click="goto(constants.BINANCE)">
            <img src="../assets/binance.png" width="50px" alt="">
          </div>
          <div class="info">
            <div class="name">BINANCE</div>
            <div class="url">https://www.binance.com</div>
          </div>
          <div class="seting">
            <el-button icon="Setting" size="small" @click="toggleForm(1)">API KEY</el-button>
          </div>
        </div>
        <div v-if="activeDiv === 1" class="form">
          <el-form>
            <el-form-item label="">
              <el-input type="textarea" :rows="2" v-model="binanceForm.ApiKey" placeholder="API_KEY"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input type="textarea" :rows="2" v-model="binanceForm.Secret" placeholder="API_SECRET"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="display: flex; justify-content: flex-end; width: 100%;">
                <el-button @click="save(constants.BINANCE)" :loading="saveloading">保存</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="driver"></div>
        <div class="item" v-loading="okxLoading" element-loading-text="正在验证 API KEY ...">
          <div class="avatar" @click="goto(constants.OKX)" style="background: #3a3a3a;">
            <img src="../assets/okx.png" width="50px" alt="">
          </div>
          <div class="info">
            <div class="name">OKX</div>
            <div class="url">https://www.okx.com</div>
          </div>
          <div class="seting">
            <el-button icon="Setting" size="small" @click="toggleForm(2)">API KEY</el-button>
          </div>
        </div>
        <div v-if="activeDiv === 2" class="form">
          <el-form>
            <el-form-item label="">
              <el-input type="textarea" :rows="2" v-model="okxForm.ApiKey" placeholder="ApiKey"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input type="textarea" :rows="2" v-model="okxForm.Secret" placeholder="Secret"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="okxForm.Passphrase" placeholder="Passphrase"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="display: flex; justify-content: flex-end; width: 100%;">
                <el-button @click="save(constants.OKX)" :loading="saveloading">保存</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="2"></el-col>
      <el-col :span="4">
        <div class="tool title">工具</div>
        <div class="tool">
          <el-card shadow="always">
            <div class="toolitem" @click="goto(constants.CALCULATOR)">
              <div class="img"><img src="../assets/computer.png" width="20px" alt=""></div>
              <div class="name">仓位计算器</div>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="5">
      </el-col>
    </el-row>
    <Calculator ref="CalculatorRef" />
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.loading-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.top {
  position: fixed;
  height: 40px;
  width: 1000px;
  padding-top: 10px;
  left: 50%;
  transform: translateX(-50%);
  text-align: right;
}

.container {
  padding-top: 150px;
  width: 1000px;
  margin: 0 auto;
}

.avatar:hover {
  cursor: pointer;
}

.avatar:hover~.info,
.avatar:hover~.seting,
.avatar:hover {
  /* 这个选择器不能直接选中父元素，所以需要用下面的方法 */
}

/* 使用父元素选择器（:has）- 现代浏览器支持 */
.item:has(.avatar:hover) {
  transform: translate(-5px, -5px);
  border-color: #3a3a3a;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.item {
  position: relative;
  display: flex;
  height: 50px;
  border: 7px solid transparent;
  transition: all 0.3s ease;
  padding: 10px;
}

.item .avatar {
  width: 50px;
  cursor: pointer;
  background: #3a3a3a;
  border-radius: 5px;
}

.item .info {
  flex: 1;
  padding-left: 10px;
}

.item .info .name {
  height: 25px;
  line-height: 25px;
}

.item .info .url {
  height: 25px;
  line-height: 25px;
  font-size: 10px;
}

.item .seting {
  width: 100px;
}

.form>>>.el-textarea__inner {
  font-size: 11px !important;
}

.form>>>.el-input__inner {
  font-size: 11px !important;
}

.driver {
  height: 1px;
  border-bottom: 1px solid #3a3a3a;
  margin: 30px 0;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.form {
  margin: 10px 0;
}

.tool {
  margin-bottom: 20px;
  cursor: pointer;
}

.toolitem {
  display: flex;
}

.toolitem .img {
  width: 40px;
}

.toolitem .name {
  flex: 1;
}

.tip {
  text-align: center;
  height: 50px;
  line-height: 40px;
}
</style>
<script setup>
import { useRouter } from 'vue-router'
import { ref, provide, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { Helper } from '@/service'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import * as constants from '@/utils/constants'
import Database from '@/service/database'
import CryptoService from '@/service/crypto.js'
import BinancePrivateClient from '@/service/binancePrivateClient.js'
import OkxPrivateClient from '@/service/okxPrivateClient.js'
import Calculator from "@/components/calculator/Index.vue"
import Login from "@/components/Login.vue"

const showLogin = ref(true)
const binanceLoading = ref(false)
const okxLoading = ref(false)
const systemStore = useSystemStore()
const logStore = useLogStore()
const router = useRouter()
const activeDiv = ref(null)
const saveloading = ref(false)
const platform = ref("")
const cryptoService = new CryptoService()
const binanceForm = reactive({
  Id: "",
  ApiKey: "",
  Secret: "",
})
const okxForm = reactive({
  Id: "",
  ApiKey: "",
  Secret: "",
  Passphrase: "",
})
const CalculatorRef = ref(null)

const load = async () => {
  //读取API
  let _apis = await Database.select("Api")

  let _binanceApi = _apis.find(x => x.ApiType == constants.BINANCE)
  let _okxApi = _apis.find(x => x.ApiType == constants.OKX)

  if (_binanceApi) {
    try {
      binanceForm.Id = _binanceApi.Id
      binanceForm.ApiKey = _binanceApi.ApiKey && await cryptoService.decrypt(_binanceApi.ApiKey, systemStore.password)
      binanceForm.Secret = _binanceApi.Secret && await cryptoService.decrypt(_binanceApi.Secret, systemStore.password)
    } catch (error) {
      console.error('Failed to decrypt API Key:', error)
    }
  }

  if (_okxApi) {
    try {
      okxForm.Id = _okxApi.Id
      okxForm.ApiKey = _okxApi.ApiKey && await cryptoService.decrypt(_okxApi.ApiKey, systemStore.password)
      okxForm.Secret = _okxApi.Secret && await cryptoService.decrypt(_okxApi.Secret, systemStore.password)
      okxForm.Passphrase = _okxApi.Passphrase && await cryptoService.decrypt(_okxApi.Passphrase, systemStore.password)
    } catch (error) {
      console.error('Failed to decrypt API Key:', error)
    }
  }
}

const goto = async (type) => {
  platform.value = type

  if (type === constants.BINANCE) {
    verifyBinanceApi()
  }
  else if (type === constants.OKX) {
    verifyOkxApi()
  }
  else if (type === constants.CALCULATOR) {
    calculator()
  }
}

const toggleForm = (divNumber) => {
  activeDiv.value = activeDiv.value === divNumber ? null : divNumber
}

const save = async (type) => {
  saveloading.value = true

  try {
    let _Id = ""
    let _ApiKey = ""
    let _Secret = ""
    let _Password = ""

    switch (type) {
      case constants.BINANCE:
        _Id = binanceForm.Id
        _ApiKey = binanceForm.ApiKey
        _Secret = binanceForm.Secret
        break
      case constants.OKX:
        _Id = okxForm.Id
        _ApiKey = okxForm.ApiKey
        _Secret = okxForm.Secret
        _Password = okxForm.Passphrase
        break
    }

    if (_Id) await Database.delete("Api", _Id)

    await Database.insert('Api', {
      Id: Helper.NewId(),
      ApiKey: _ApiKey && await cryptoService.encrypt(_ApiKey, systemStore.password),
      Secret: _Secret && await cryptoService.encrypt(_Secret, systemStore.password),
      Passphrase: _Password && await cryptoService.encrypt(_Password, systemStore.password),
      ApiType: type
    })

    saveloading.value = false
    ElMessage.success('保存成功')
    activeDiv.value = null

  } catch (error) {
    saveloading.value = false
    ElMessage.error('保存失败' + error)
    logStore.addLog({
      title: '保存 API Key 失败',
      level: 'error',
      message: error
    })
  }
}

const verifyBinanceApi = async () => {
  if (!binanceForm.ApiKey || !binanceForm.Secret) {
    ElMessage.error('先完善 Binance API KEY')
    return
  }

  try {
    binanceLoading.value = true

    const client = new BinancePrivateClient({
      apiKey: binanceForm.ApiKey,
      secret: binanceForm.Secret
    })
    await client.accountInfo()

    systemStore.setAssetType(constants.BINANCE)
    systemStore.setPlatform(platform.value)
    systemStore.setApi({
      apiKey: binanceForm.ApiKey,
      secret: binanceForm.Secret
    })
    systemStore.initBinanceClient()
    binanceLoading.value = false
    router.push({ path: "/dashboard" })
  } catch (error) {
    binanceLoading.value = false
    ElMessage.error('API Key 验证失败 ❌')
    logStore.addLog({
      title: 'API Key 验证失败',
      level: 'error',
      message: error
    })
  }
}

const verifyOkxApi = async () => {
  if (!okxForm.ApiKey || !okxForm.Secret || !okxForm.Passphrase) {
    ElMessage.error('先完善 Okx API KEY')
    return
  }

  try {
    okxLoading.value = true

    const privateClient = new OkxPrivateClient({
      apiKey: okxForm.ApiKey,
      secret: okxForm.Secret,
      passphrase: okxForm.Passphrase
    })

    await privateClient.getBalance()
    systemStore.setAssetType(constants.OKX)
    systemStore.setPlatform(platform.value)

    systemStore.setApi({
      apiKey: okxForm.ApiKey,
      secret: okxForm.Secret,
      passphrase: okxForm.Passphrase
    })

    systemStore.initOkxClient()
    okxLoading.value = false
    router.push({ path: "/dashboard" })
  } catch (error) {
    okxLoading.value = false
    ElMessage.error('API Key 验证失败 ❌' + error)
    logStore.addLog({
      title: 'API Key 验证失败',
      level: 'error',
      message: error
    })
  }
}

const calculator = async () => {
  CalculatorRef.value.showDialog()
}

const loginReady = () => {
  showLogin.value = false
  load()
}

const homeActions = {
  loginReady: () => loginReady(),
}

provide("homeActions", homeActions)

</script>
